import { gql, useMutation } from "@apollo/client"

const UPLOAD_DOCUMENT_QUERY = gql`
  mutation OffboardingCreateDocument(
    $entityId: ID!
    $signedDocumentId: String!
    $title: String!
    $description: String
  ) {
    createDocument(
      input: {
        entityId: $entityId
        signedDocumentId: $signedDocumentId
        title: $title
        description: $description
      }
    ) {
      errors
    }
  }
`

export const useCreateDocumentMutation = () => useMutation(UPLOAD_DOCUMENT_QUERY)
